<template>
  <div class="px-3 mb-3">
    <span :class="CSS_COMPUTED">{{ valor }}</span>
    {{ label }}
  </div>
</template>

<script>
export default {
  name: "Badge",
  props: {
    label: {
      type: String,
      required: true
    },
    valor: {
      type: [String, Number],
      required: true
    },
    outline: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  computed: {
    CSS_COMPUTED() {
      return {
        'font-weight-medium font-14 bra-8 px-4 mr-1 py-1 bg-gray-100': this.outline,
        'font-weight-medium font-14 bra-8 px-4 mr-1 py-1 bg-gray-300': !this.outline
      };
    }
  }
}
</script>

<style scoped>

</style>
